import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Dropdown, MenuItem, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import { addRow, addRowBottom } from '../actions/index';

class addNewRowButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      visibility: false,
      layouts:[
        {
          id: 0,
          size: '12',
          icon: 'pbfont pbfont-12',
          className: 'layout-12'
        },
        {
          id: 1,
          size: '6,6',
          icon: 'pbfont pbfont-6-6',
          className: 'layout-66'
        },
        {
          id: 2,
          size: '4,4,4',
          icon: 'pbfont pbfont-4-4-4',
          className: 'layout-444'

        },
        {
          id: 3,
          size: '3,3,3,3',
          icon: 'pbfont pbfont-3-3-3-3',
          className: 'layout-3333'

        },
        {
          id: 4,
          size: '8,4',
          icon: 'pbfont pbfont-8-4',
          className: 'layout-84'
        },
        {
          id: 5,
          size: '3,9',
          icon: 'pbfont pbfont-3-9',
          className: 'layout-39'
        },
        {
          id: 6,
          size: '3,6,3',
          icon: 'pbfont pbfont-3-6-3',
          className: 'layout-363'
        },
        {
          id: 7,
          size: '2,10',
          icon: 'pbfont pbfont-2-10',
          className: 'layout-210'
        },
        {
          id: 8,
          size: '2,5,5',
          icon: 'pbfont pbfont-2-5-5',
          className: 'layout-255'
        },
        {
          id: 9,
          size: '6,6,12',
          icon: 'pbfont pbfont-6-6-12',
          className: 'layout-6612'
        }
      ]
    };
  }

  _rednerDropDown(){
    const { layouts } = this.state;

    return(
      layouts.map(( layout, index) =>
      <li key={index} onClick={e => {
        if (this.props.bottom) {
          this.props.addNewRowBottom(this.props.index, layout.size);
        } else {
          this.props.addNewRow(layout.size);
        }
        this.setState({
          isOpen: false,
          visibility: false,
        })
      }}><i className={layout.icon} ></i></li>
    ))
  }

  _generateCustomLayout(){

    var customLayout = this.refs.customLayout.value;

    if ( customLayout !== '' ) {

      var correctSize = customLayout.split('+')
      .filter(function(el){
        var regEx = /[A-Za-z]/;
        if( regEx.exec(el) == null && (el > 0 && el <= 12) ) {
          return el;
        }
      })
      .join(',');

      if (correctSize != '') {
        if (this.props.bottom) {
          this.props.addNewRowBottom(this.props.index, correctSize);
        } else {
          this.props.addNewRow(correctSize);
        }

      }
    }

    this.setState({
      isOpen: false,
      visibility: false
    });
  }

  toggleLayout () {
    const { isOpen } = this.state;
    const { visibility } = this.state;

    if (!visibility) {
      this.setState({ isOpen: !isOpen })
    }
  }

  keepOpen () {
    this.setState({visibility: true});
  }

  handleClose(){
    this.setState({visibility: false});
  }

  onclickHandle(){
    const { visibility } = this.state;
    this.setState({visibility: !visibility});
  }

  render(){
    const { isOpen } = this.state;

    return(
      <Dropdown
        id="sppb-add-new-row-btn"
        open={this.state.isOpen}
        onClose={this.handleClose.bind(this)}
        onToggle={this.toggleLayout.bind(this)}
        dropup
        >
        <Dropdown.Toggle
          onClick={this.onclickHandle.bind(this)}
          bsClass=""
          bsStyle="link"
          className="sp-pagebuilder-btn sp-pagebuilder-btn-primary sp-pagebuilder-btn-lg"
          >
          { this.props.bottom ? <i className="pbfont pbfont-plus"></i> : <i className="pbfont pbfont-plus-circle"></i> }{ !this.props.bottom && Joomla.JText._("COM_SPPAGEBUILDER_ADD_NEW_ROW")}
        </Dropdown.Toggle>
        <Dropdown.Menu className="sp-pagebuilder-dropdown-row-layouts">
          <div className="sp-pagebuilder-layouts-container" >
            <div className="sp-pagebuilder-layouts-container-inner">
              <ul className="sp-pagebuilder-layouts-list clearfix">
                { this._rednerDropDown() }
              </ul>
              <div className="sp-pagebuilder-custom-layout clearfix">
                <div>
                  <span>{Joomla.JText._("COM_SPPAGEBUILDER_ROW_COLUMNS_CUSTOM")}</span>
                </div>
                <div>
                  <input
                    type="text"
                    ref="customLayout"
                    onSelect={this.keepOpen.bind(this)}
                    defaultValue='4+4+4'
                    placeholder="4+4+4" />
                </div>
                <div>
                  <a
                    href="#"
                    className="sp-pagebuilder-btn sp-pagebuilder-btn-primary sp-pagebuilder-btn-block"
                    onClick={(e) => {
                      e.preventDefault();
                      this._generateCustomLayout()
                    }}>
                    {Joomla.JText._("COM_SPPAGEBUILDER_ROW_COLUMNS_GENERATE")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

const mapStateToProps = ( state ) => {
  return {
    state: state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {

    addNewRow: (layout) => {
      dispatch(addRow(layout))
    },
    addNewRowBottom: (index, layout) => {
      dispatch(addRowBottom(index, layout))
    }

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(addNewRowButton);



// WEBPACK FOOTER //
// ./src/components/AddNewRowButton.js